import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import PodcastDetail from "@/pages/PodcastDetail";
import SelfTestPage from "@/pages/SelfTest";
import Help from "@/pages/Help";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/podcast/:slug" element={<PodcastDetail />} />
            <Route path="/selbsttest" element={<SelfTestPage />} />
            <Route path="/selftest" element={<SelfTestPage />} />
            <Route path="/hilfe" element={<Help />} />
            <Route path="/help" element={<Help />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <InstallPrompt />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            classNames: {
              toast:
                "border border-white/10 bg-[#141414] text-[#FAFAFA] rounded-none font-mono-plex text-sm",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
